import React, { useState, useEffect } from 'react'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import {
  getHumanReadableDate,
  getRequest,
  postRequest
} from '../../globalhelper/helper'
import '../CI/COD.css'
import VR2_Forms from '../../pages/VR2_Form_Rendering/displayContainer'
import Popup from '../../components/SimplePOPUP'
import moment from 'moment'
import Select from 'react-select'
import _ from 'lodash'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography
} from '@mui/material'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'

const CostAllocation_Search = props => {
  const [formData, setFormData] = useState({})
  const [screenAction, setScreenAction] = useState('')
  const [showtable, setShowtable] = useState(false)
  const [tableData, setTableData] = useState([])
  const [dropdown_costallocationmethod, setDropdownCostallocationmethod] =
    useState([])
  const [dropdown_forprdfrom, setDropdownForprdfrom] = useState([])
  const [forprdfrom, setForprdfrom] = useState(null)
  const [isBetweenDates, setIsBetweenDates] = useState(true)
  const [dropdown_orgname, setDropdownOrgname] = useState([])
  const [companyDetails, setCompanyDetails] = useState([])
  const [error, setError] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [redirect, setRedirect] = useState(false)
  const [SearchJSON, setSearchJSON] = useState([])
  const [noQuit, setNoQuit] = useState(false)
  const [create_Clone, setCreateClone] = useState(false)
  const [oneitem, setOneitem] = useState(null)

  useEffect(() => {
    sessionStorage.setItem('pageName', 'Search Cost Allocation Method')

    getRequest(`api/edureka/getCompanyAssignedToUser`)
      .then(response => {
        console.log(response.res.data)
        const responseData = _.sortBy(response.res.data, 'orgname')
        const companies = responseData.map(item => ({
          orgname: item.orgname,
          orgid: item.orgid
        }))
        setCompanyDetails(companies)
        if (companies.length === 1) {
          handleChange({
            target: {
              name: 'company',
              value: companies[0]
            }
          })
        }
      })
      .catch(err => console.log(err))
  }, [])

  const handleChange = e => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
    if (name === 'company') {
      setShowtable(false)
      setDropdownCostallocationmethod([])
      handleCostMethod(value)
    }
  }

  const handleCostMethod = VALUE => {
    if (VALUE) {
      getRequest(
        `api/edureka/getCostAllocationMethodDropdown?orgid=${VALUE?.orgid}`
      ).then(response => {
        console.log(response.res.data)
        const costAllocation = response.res.data.map(item => ({
          name: item.costallocationmethod,
          value: item.costallocationmethod
        }))
        setDropdownCostallocationmethod(costAllocation)
      })
    }
  }

  const handleReset = () => {
    setShowtable(false)
    setError(false)
    setFormData({})
    console.log(formData)
  }

  const handleSearch = () => {
    const cam = formData?.costallocationmethod?.value
    console.log(formData)

    if (cam && formData.company.orgname) {
      setError(false)
      postRequest(`api/edureka/getCostAllocationSearchData`, {
        cam: cam,
        orgid: formData.company.orgid
      }).then(res => {
        if (res.res.status === 'success') {
          let temp = JSON.parse(res.res.data)
          console.log(temp)
          setTableData(temp)
          setShowtable(true)
        } else {
          console.log('No Data')
        }
      })
    } else {
      setError(true)
      setErrorMessage('Please select all the required fields')
    }
  }

  const handleCAM = i => {
    const method = i['costallocationmethod']
    const date = getHumanReadableDate(i['forprdfrom'])
    setNoQuit(false)
    localStorage.setItem(
      'api',
      `api/edureka/getCostAllocationUpdatedJSON?date=${date}&orgid=${formData.company.orgid}&method=${method}`
    )
    window.open(
      `/Dynamic_Forms?token=CostAllocationMaster&action=edit&orgId=${formData.company.orgid}&docId=${method}`,
      '_blank'
    )
    // postRequest(
    //   `api/edureka/getCostAllocationUpdatedJSON?date=${date}&orgid=${formData.company.orgid}&method=${i['costallocationmethod']}`,
    //   { method: method }
    // ).then(res => {
    //   if (res.res.status === 'success') {
    //     console.log(res.res.data)
    //     setScreenAction('edit')
    //     const data =
    //       typeof res.res.data === 'string'
    //         ? JSON.parse(res.res.data)
    //         : res.res.data
    //     setSearchJSON(data)
    //     if (data.length > 1) {
    //       setRedirect(true)
    //     }
    //     setNoQuit(false)
    //   } else {
    //     console.log('No Data')
    //   }
    // })
  }

  const isBetweenDatesfn = (givenDate, startDate, endDate) => {
    const given = new Date(givenDate)
    const start = new Date(startDate)
    const end = new Date(endDate)
    return start <= given && given <= end
  }

  const onDateChn = newValue => {
    let giveDate = moment(newValue).format('YYYY-MM-DD')
    console.log(giveDate, oneitem.forprdfrom, oneitem.forprdto)

    let isBetween = isBetweenDatesfn(
      giveDate,
      oneitem.forprdfrom,
      oneitem.forprdto
    )
    setForprdfrom(giveDate)
    setIsBetweenDates(isBetween)
  }

  const copyItem = item => {
    console.log(item, 'item')
    setOneitem(item)
    setCreateClone(true)
  }

  const create_Clonefn = e => {
    e.preventDefault()

    let item = oneitem
    const cloneForprdfrom = forprdfrom

    console.log(cloneForprdfrom, formData)

    if (cloneForprdfrom) {
      const sourceDate = item.forprdfrom
      let Item = JSON.parse(JSON.stringify(item))

      if (sourceDate !== cloneForprdfrom) {
        const id = companyDetails.filter(
          item => item.orgname === formData.orgname
        )
        const companyid = id.map(item => item.orgid)

        let input = {
          method: Item.costallocationmethod,
          date: moment(cloneForprdfrom, 'YYYY-MM-DD').format('DD-MM-YYYY'),
          sourceDate: moment(sourceDate, 'YYYY-MM-DD').format('DD-MM-YYYY'),
          orgid: formData.company.orgid || ''
        }

        postRequest(`api/edureka/costAllocationCopyJSON`, input).then(res => {
          if (res.res.status === 'success') {
            let JSON = res.res.data
            console.log(JSON)
            setCreateClone(null)
            setForprdfrom(null)
            setRedirect(true)
            setScreenAction('PartialCreate')
            setSearchJSON(JSON)
            setNoQuit(true)
          } else {
            console.log('fail')
          }
        })
      } else {
        setCreateClone(null)
        setForprdfrom(null)
      }
    }
  }

  const onBack = () => {
    setRedirect(false)
    setSearchJSON([])
  }

  if (redirect) {
    return (
      <VR2_Forms
        screenName={'CostAllocationMaster'}
        screenAction={screenAction}
        noQuit={noQuit}
        From_SearchJSON={SearchJSON}
        onBack={onBack}
      />
    )
  }

  return (
    <>
      {create_Clone && (
        <Dialog
          open={create_Clone}
          onClose={() => setCreateClone(false)}
          fullWidth
          maxWidth='xs'
        >
          <DialogTitle>Clone</DialogTitle>

          <DialogContent>
            <Box
              display='flex'
              flexDirection='column'
              alignItems='center'
              mt={1}
              mb={2}
            >
              <Typography variant='body1' mb={1}>
                For Period From :
              </Typography>

              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                  label='ForPrdFrom'
                  value={formData.toDate}
                  views={['day', 'month', 'year']}
                  onChange={onDateChn}
                  renderInput={params => (
                    <TextField fullWidth size='small' {...params} />
                  )}
                />
              </LocalizationProvider>
            </Box>

            <Box textAlign='center' mt={2}>
              <Button
                variant='contained'
                color='success'
                onClick={create_Clonefn}
                disabled={isBetweenDates}
              >
                Copy
              </Button>
            </Box>
          </DialogContent>
        </Dialog>
      )}

      <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls='panel3-content'
          id='panel3-header'
        >
          <Typography variant='h6'>Search CostAllocationMaster</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={3}>
            <Grid item xl={4}>
              <Autocomplete
                disablePortal
                options={companyDetails.sort((a, b) =>
                  a.orgname.localeCompare(b.orgname)
                )}
                getOptionLabel={companyDetails => companyDetails?.orgname || ''}
                getOptionKey={companyDetails => companyDetails?.orgid || ''}
                value={formData?.company || ''}
                onChange={(e, newValue) =>
                  handleChange({
                    target: {
                      name: 'company',
                      value: newValue
                    }
                  })
                }
                renderInput={params => (
                  <TextField
                    size='small'
                    {...params}
                    name='organizationname'
                    label='Organization Name'
                  />
                )}
              />
            </Grid>
            <Grid item xl={4}>
              <Autocomplete
                options={dropdown_costallocationmethod}
                getOptionLabel={dropdown_costallocationmethod =>
                  dropdown_costallocationmethod?.name || ''
                }
                getOptionKey={dropdown_costallocationmethod =>
                  dropdown_costallocationmethod?.value || ''
                }
                value={
                  formData.costallocationmethod
                    ? dropdown_costallocationmethod.find(
                      opt => opt === formData.costallocationmethod
                    ) || null
                    : null
                }
                onChange={(e, newValue) =>
                  handleChange({
                    target: {
                      name: 'costallocationmethod',
                      value: newValue
                    }
                  })
                }
                renderInput={params => (
                  <TextField
                    size='small'
                    {...params}
                    name='costallocationmethod'
                    label='Costallocation Method'
                  />
                )}
              />
            </Grid>
            <br />
            <Grid item xl={1}>
              <Button
                variant='contained'
                color='primary'
                onClick={handleSearch}
              >
                Search
              </Button>
            </Grid>
            <Grid item xl={1}>
              <Button
                style={{ marginLeft: 10 }}
                variant='contained'
                color='error'
                onClick={handleReset}
              >
                Reset
              </Button>
            </Grid>
            <Grid item xl={1}>
              <Button
                style={{ marginLeft: 10 }}
                variant='contained'
                color='warning'
                onClick={() => props.onBack()}
              >
                Back
              </Button>
            </Grid>
          </Grid>
        </AccordionDetails>
    </Accordion >
      <br />

  {
    showtable && tableData.length > 0 ? (
      <div>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label='simple table'>
            <TableHead>
              <TableRow>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>
                  Cost Allocation Method
                </TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>
                  For Period From
                </TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>
                  For Period To
                </TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>
                  Allocation Type
                </TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap' }}></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tableData
                .sort((a, b) =>
                  a['costallocationmethod'].localeCompare(
                    b['costallocationmethod']
                  )
                )
                .map((item, index) => {
                  return (
                    <TableRow key={index}>
                      <TableCell sx={{ whiteSpace: 'nowrap' }}>
                        <Button
                          variant='text'
                          color='primary'
                          onClick={() => handleCAM(item)}
                        >
                          {item['costallocationmethod']}
                        </Button>
                      </TableCell>
                      <TableCell sx={{ whiteSpace: 'nowrap' }}>
                        {item['forprdfrom']}
                      </TableCell>
                      <TableCell sx={{ whiteSpace: 'nowrap' }}>
                        {item['forprdto']}
                      </TableCell>
                      <TableCell sx={{ whiteSpace: 'nowrap' }}>
                        {item['allocationtype']}
                      </TableCell>
                      <TableCell sx={{ whiteSpace: 'nowrap' }}>
                        <Button
                          style={{ marginLeft: 10 }}
                          variant='contained'
                          color='success'
                          disabled={!item['forprdfrom'] || !item['forprdto']}
                          onClick={() => copyItem(item)}
                        >
                          Copy
                        </Button>
                      </TableCell>
                    </TableRow>
                  )
                })}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    ) : null
  }

  { error ? <div className='center-screen'>{errorMessage}</div> : null }
    </>
  )
}

export default CostAllocation_Search
